<template>
    <div class="emoji-picker-wrapper" @wheel.stop>
        <emoji-picker ref="picker"></emoji-picker>
  </div>
</template>

<script>
    import 'lib/emoji-picker-element'
    import { mapGetters } from 'vuex'
    import fr from 'lib/emoji-picker-element/i18n/fr'
    import de from 'lib/emoji-picker-element/i18n/de'

    export default {
        computed: {
            ...mapGetters(['language'])
        },

        mounted() {
            this.setLanguage()
            this.$refs.picker.addEventListener('emoji-click', this.handleEmoji)
            this.focusSearch()
        },

        beforeDestroy() {
            this.$refs.picker.removeEventListener('emoji-click', this.handleEmoji)
        },

        methods: {
            handleEmoji(event) {
                this.$emit('onSelect', event.detail.unicode)
            },

            focusSearch() {
                this.$nextTick(() => {
                    const shadow = this.$refs.picker.shadowRoot
                    if (!shadow) return
                    const searchInput = shadow.querySelector('input[type="search"]')
                    if (searchInput) {
                        searchInput.focus()
                    }
                })
            },

            setLanguage() {
                if(this.language) {
                    switch (this.language) {
                        case "de_DE":
                            this.$refs.picker.i18n = de
                            this.$refs.picker.locale = de
                            this.$refs.picker.dataSource = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@1.8.0/de/cldr/data.json'
                            break
                        case "fr":
                            this.$refs.picker.i18n = fr
                            this.$refs.picker.locale = fr
                            this.$refs.picker.dataSource = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/fr/emojibase/data.json'
                            break
                    }
                }
            }
        },

        watch: {
            language: {
                handler: function(val) {
                    if(val) {
                        this.setLanguage()
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '_assets/emojipicker';
</style>